/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScanResult = {
    /**
     * Unique ID of the measurement data.
     */
    measurementID?: string;
    /**
     * Result status of the scan.
     */
    status: ScanResult.status;
    /**
     * Returned status code.
     */
    statusCode: number;
    /**
     * End message of the scanning session.
     */
    message: string;
    /**
     * Time elapsed during scan.
     */
    timeElapsed: number;
    /**
     * Part of the body that was scanned.
     */
    bodyPart?: ScanResult.bodyPart;
    /**
     * The side of the body part that was scanned.
     */
    side?: ScanResult.side;
    /**
     * Size of scan data in megabytes.
     */
    sizeMB: number;
};
export namespace ScanResult {
    /**
     * Result status of the scan.
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
    }
    /**
     * Part of the body that was scanned.
     */
    export enum bodyPart {
        FOOT = 'FOOT',
        FOOT_AND_ANKLE = 'FOOT_AND_ANKLE',
        HEAD = 'HEAD',
        TORSO = 'TORSO',
    }
    /**
     * The side of the body part that was scanned.
     */
    export enum side {
        LEFT = 'LEFT',
        RIGHT = 'RIGHT',
        BOTH = 'BOTH',
    }
}

